<template>
  <FormDropdownSearchAsync
    :model-value="formattedModelValue"
    :name="name"
    :input-classes="inputClasses"
    :input-styles="inputStyles"
    :label="label"
    :label-hint="labelHint"
    autocomplete="off"
    @update:modelValue="handleUpdateModelValue"
    :placeholder="placeholder"
    :get-options="(params) => usaCities(params)"
    class="w-full"
  />
</template>

<script setup>
import FormDropdownSearchAsync from "./FormDropdownSearchAsync.vue";
import {usaCities} from "../constants/Lists.js";
import {computed} from "vue";

const emits = defineEmits(["update:modelValue", "update:lat", "update:lng", "update:line1", "update:line2", "update:city", "update:state", "update:country", "update:postalCode"]);
const props = defineProps({
  label: String,
  labelHint: String,
  placeholder: {
    type: String,
    default: "Start typing any US city"
  },
  name: String,
  lat: Number,
  lng: Number,
  line1: String,
  line2: String,
  city: String,
  state: String,
  country: String,
  postalCode: String,
  required: Boolean,
  alwaysFlexCol: Boolean,
  shortButton: Boolean,
  inputStyles: String,
  inputClasses: String,
});

const formattedModelValue = computed(() => {
  if (!props.city || !props.state || !props.lat || !props.lng) return "";
  return `${props.city}, ${props.state}, USA`;
});

const handleUpdateModelValue = (value) => {
  if (!value) clearInput();

  emits("update:modelValue", value.name);
  emits("update:lat", value.lat);
  emits("update:lng", value.lng);
  emits("update:line1", "");
  emits("update:line2", "");
  emits("update:city", value.city);
  emits("update:state", value.state);
  emits("update:country", value.country || "USA");
  emits("update:postalCode", "");
};

const clearInput = () => {
  emits("update:modelValue", "");
  emits("update:lat", null);
  emits("update:lng", null);
  emits("update:line1", "");
  emits("update:line2", "");
  emits("update:city", "");
  emits("update:state", "");
  emits("update:country", "");
  emits("update:postalCode", "");
};

const searchAndSelectFirst = async (search) => {
  try {
    const cities = await usaCities({search});
    if (cities.data.length) handleUpdateModelValue(cities.data[0]);
    else clearInput();
  } catch (e) {
    console.error(e);
    clearInput();
  }
};

defineExpose({searchAndSelectFirst});
</script>
